







































import { cloneDeep, isEqual } from 'lodash'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import ConfigField from '../../ConfigField/ConfigField.vue'
import HighlightAnchor from '../../HighlightAnchor.vue'
import { Field, FieldTranslationsKeys } from '../mixins'
import Validation from './Validation.vue'

@Component({
  components: {
    HighlightAnchor,
    ConfigField,
    Validation,
  },
})
export default class FieldWrapper extends Mixins(Field, FieldTranslationsKeys) {
  @Prop({ type: Boolean }) readonly inline!: boolean | any

  @Prop() customDefaultValue!: any

  @Emit()
  disabledSettingValueTriggered() {
    return true
  }

  @Emit()
  resetToDefaultTriggered() {
    return true
  }

  @Emit()
  rollbackTriggered() {
    return this.backup
  }

  @Emit()
  setBackup(value: any) {
    return value
  }

  backup: any = null

  get required(): boolean {
    return this.validation.includes('required')
  }

  // get translationsKeysMap(): { [key: string]: any } {
  //   let key = snakeCase(this.propertyKey)
  //
  //   const { prefix } = this.settings
  //   if (prefix) {
  //     key = prefix + key
  //   }
  //   return {
  //     title: `field_${ key }_title`,
  //     helpMessage: this.$te(`field_${ key }_help_message_project`) ? `field_${ key }_help_message_project` : `field_${ key }_help_message`,
  //     miniHelpMessage: this.$te(`field_${ key }_mini_help_message_project`) ? `field_${ key }_mini_help_message_project` : `field_${ key }_mini_help_message`,
  //     badExampleText: `field_${ key }_bad_example_text`,
  //     badExampleTextTitle: `field_${ key }_bad_example_text_title`,
  //     goodExampleText: `field_${ key }_good_example_text`,
  //     goodExampleTextTitle: `field_${ key }_good_example_text_title`,
  //     instructionLink: `field_${ key }_instruction_link`,
  //   }
  // }
  //
  // get propsData(): { [key: string]: any } {
  //   const propsData: { [key: string]: any } = {}
  //
  //   // PROCESS TRANSLATIONS
  //   for (const key of Object.keys(this.translationsKeysMap)) {
  //     if ([ 'title' ].includes(key)) {
  //       propsData[key] = this.$t(this.translationsKeysMap[key], this.translationParams)
  //     } else {
  //       propsData[key] = this.$te(this.translationsKeysMap[key]) ? this.$t(this.translationsKeysMap[key], this.translationParams) : ''
  //     }
  //   }
  //
  //   return propsData
  // }

  get inlineValue(): boolean {
    if (this.settings.inline !== undefined) {
      return this.settings.inline
    }

    return this.inline
  }

  get titleVisible():boolean {
    if (this.settings.titleVisible === undefined) return true

    return this.settings.titleVisible
  }

  get hasAnchor():boolean {
    if (this.settings.hasAnchor === undefined) return false

    return this.settings.hasAnchor
  }

  get anchorKey(): string | undefined {
    return this.settings?.anchorKey
  }

  // get translationParams(): FieldData['translationParams'] {
  //   if (this.settings.translationParams === undefined) return []
  //   return this.settings.translationParams
  // }

  get customHelpMessage() {
    if (this.settings.customHelpMessage === undefined) return undefined

    return this.settings.customHelpMessage
  }

  get handleValueDiffByBackup():boolean {
    return !isEqual(this.backup, this.settings.model[this.settings.key])
  }

  // eslint-disable-next-line getter-return,consistent-return,@typescript-eslint/ban-types
  get getResetValueToDefault(): Function | undefined {
    if (this.defaultValue !== undefined) {
      return this.resetValueToDefault
    }
  }

  rollBackValue(): void {
    if (this.settings.setter) {
      this.settings.setter(this.backup)
    }
  }

  get getDisabledSettingValue() {
    if (this.settingWrapperDisabledValue !== undefined && this.settings.setter) {
      return this.disableModelToDisableSetting
    }

    return undefined
  }

  disableModelToDisableSetting() {
    if (this.settingWrapperDisabledValue !== undefined && this.settings.setter) {
      return this.settings.setter(this.settingWrapperDisabledValue)
    }
  }

  resetValueToDefault(): void {
    if (this.defaultValue !== undefined && this.settings.setter) {
      if (this.customDefaultValue !== undefined && typeof this.customDefaultValue === 'function') {
        this.customDefaultValue()
      } else {
        this.settings.setter(cloneDeep(this.defaultValue))
      }
    }
  }

  mounted(): void {
    this.$nextTick(() => {
      this.backup = cloneDeep(this.settings.model[this.settings.key]);
      this.setBackup(this.backup)
    })
  }
}
